<template>
<highcharts :options="options" />
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { chartColorSet } from '@/constants/chart-options';

const options = {
  chart: {
    type: 'pie',
    height: '300px',
  },
  title: false,
  credits: false,
  legend: {
    layout: 'vertical',
    verticalAlign: 'middle',
    align: 'right',
  },
  plotOptions: {
    pie: {
      showInLegend: true,
      dataLabels: {
        enabled: false,
      },
    },
  },
  tooltip: {
    formatter() {
      return `대상: ${this.key}<br> 성능값: ${this.y}`;
    },
  },
  series: [],
  colors: chartColorSet,
};

export default {
  name: 'WMemoryPieChart',
  props: {
    performanceData: Object,
    objtypeId: String,
  },
  data() {
    return {
      options: cloneDeep(options),
      rscInfoList: {
        ORACLE: [
          {
            rsctypeId: 'OR_MEMSTAT',
            rscId: 'DBOR_SGA_BUF_CACHE_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'OR_MEMSTAT',
            rscId: 'DBOR_SGA_FIXED_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'OR_MEMSTAT',
            rscId: 'DBOR_SGA_KEEP_POOL_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'OR_MEMSTAT',
            rscId: 'DBOR_SGA_RECYCLE_POOL_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'OR_MEMSTAT',
            rscId: 'DBOR_SGA_REDO_BUF_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'OR_MEMSTAT',
            rscId: 'DBOR_SGA_SHARED_POOL_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'OR_MEMSTAT',
            rscId: 'DBOR_SGA_LIB_CACHE_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'OR_MEMSTAT',
            rscId: 'DBOR_SGA_DIC_CACHE_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'OR_MEMSTAT',
            rscId: 'DBOR_SGA_SQL_AREA_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'OR_MEMSTAT',
            rscId: 'DBOR_SGA_JAVA_POOL_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'OR_MEMSTAT',
            rscId: 'DBOR_SGA_LARGE_POOL_SIZE',
            rscKey: '_',
          },
        ],
        MSSQL: [
          {
            rsctypeId: 'MS_MEMSTAT',
            rscId: 'DBMS_BUF_CACHE_TOTAL_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'MS_MEMSTAT',
            rscId: 'DBMS_BUF_POOL_TOTAL_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'MS_MEMSTAT',
            rscId: 'DBMS_PROCEDURE_CACHE_TOTAL_SIZE',
            rscKey: '_',
          },
        ],
        TIBERO: [
          {
            rsctypeId: 'TB_MEMSTAT',
            rscId: 'DBTB_SGA_SHARED_POOL_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'TB_MEMSTAT',
            rscId: 'DBTB_SGA_BUF_CACHE_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'TB_MEMSTAT',
            rscId: 'DBTB_SGA_REDO_BUF_SIZE',
            rscKey: '_',
          },
          {
            rsctypeId: 'TB_MEMSTAT',
            rscId: 'DBTB_SGA_FIXED_SIZE',
            rscKey: '_',
          },
        ],
      },
    };
  },
  watch: {
    performanceData(record) {
      const series = [];
      this.rscInfoList[this.objtypeId].forEach((rscInfo) => {
        series.push({
          name: record[`${rscInfo.rsctypeId}/${rscInfo.rscId}/NAME`],
          y: parseFloat(record[`${rscInfo.rsctypeId}/${rscInfo.rscId}`]),
        });
      });

      this.options.series = [
        {
          innerSize: '50%',
          data: series,
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/chart/MemoryPieChart.vue